import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import viewIcon from '../../../assets/housep.png';
import starIcon from '../../../assets/housew.png';
import searchIcon from '../../../assets/houser.png';
import Loader from '../../../Loader/Loader';
import { selectUser } from '../../../Commonlibs/userSlice';

const ActivityCard = ({ title, icon, count, onClick }) => (
  <Box
    onClick={onClick}
    sx={{
      flex: 1,
      maxWidth: '220px',
      minWidth: '180px',
      textAlign: 'center',
      border: '1px solid #e0e0e0',
      borderRadius: '12px',
      p: '20px 10px 40px 10px',
      position: 'relative',
      background: '#fff',
      transition: 'box-shadow 0.2s ease',
      boxSizing: 'border-box',
      '&:hover': {
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      },
    }}
  >
    <img src={icon} alt={title} style={{ width: '40px', height: '40px', marginBottom: '12px' }} />
    <Typography sx={{ fontWeight: 400, fontSize: '14px', m: 0, color: '#4B5563' }}>
      {title}
    </Typography>
    <Box
      sx={{
        position: 'absolute',
        bottom: '-15px',
        left: '50%',
        transform: 'translateX(-50%)',
        background: '#fff',
        border: '1px solid #ddd',
        borderRadius: '8px',
        px: { xs: '32px', md: '60px' },
        py: '8px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
        fontWeight: 600,
        fontSize: '14px',
        color: '#333',
      }}
    >
      {count}
    </Box>
  </Box>
);

const ProfileMain = () => {
  const navigate = useNavigate();
  const user = useSelector(selectUser);
  const [analytics, setAnalytics] = useState({
    total_views: 0,
    total_favorites: 0,
    total_searches: 0,
    recently_viewed_properties: []
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBuyerAnalytics = async () => {
      try {
        setLoading(true);
        // Use the user_id from Redux store
        const buyer_id = user?.id;
        
        // Updated to match the API endpoint from your example
        const response = await fetch(`https://propertydealstalk.com/api/buyerAnalytics/getBuyerDashboardAnalytics?buyer_id=${buyer_id}`);
        const data = await response.json();
        
        if (data.statusCode === 200 && data.status === "SUCCESS") {
          setAnalytics({
            total_views: data.result.total_views,
            total_favorites: data.result.total_favorites,
            total_searches: data.result.total_searches,
            recently_viewed_properties: data.result.recently_viewed_properties || []
          });
        } else {
          console.error("Failed to fetch analytics:", data.message);
        }
      } catch (error) {
        console.error("Error fetching buyer analytics:", error);
      } finally {
        setLoading(false);
      }
    };

    if (user?.id) {
      fetchBuyerAnalytics();
    } else {
      setLoading(false);
    }
  }, [user]);

  return (
    <>
      {loading && <Loader />}
      <Box
        sx={{
          background: '#fff',
          width: '100%',
          maxWidth: '1090px',
          borderRadius: '16px',
          p: { xs: '16px', md: '44px' },
          mb: '24px',
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
          boxSizing: 'border-box',
        }}
      >
        <Typography
          sx={{
            mb: '24px',
            fontSize: '20px',
            fontWeight: 500,
            color: '#1A1A1A',
          }}
        >
          My Activity
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: { xs: 'flex-start', md: 'space-between' },
            alignItems: { xs: 'center', md: 'stretch' },
            gap: { xs: '16px', md: '20px' },
            flexWrap: 'wrap',
          }}
        >
          <ActivityCard
            title="Properties Viewed"
            icon={viewIcon}
            count={analytics.total_views}
            onClick={() => navigate('/profile/view-main')}
          />
          <ActivityCard 
            title="Wishlist Properties" 
            icon={starIcon} 
            count={analytics.total_favorites} 
            onClick={() => navigate('/profile/wishlist')}
          />
          <ActivityCard 
            title="Recent Searches" 
            icon={searchIcon} 
            count={analytics.total_searches} 
            onClick={() => navigate('/profile/recent-searches')}
          />
        </Box>
      </Box>
    </>
  );
};

export default ProfileMain;